import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const SearchFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const specialtyOptions = [
    { value: 'all', label: 'All Specialties' },
    { value: 'strength', label: 'Strength Training' },
    { value: 'cardio', label: 'Cardio & Endurance' },
    { value: 'yoga', label: 'Yoga & Flexibility' },
    { value: 'nutrition', label: 'Nutrition Coaching' },
    { value: 'sports', label: 'Sports Performance' },
    { value: 'rehabilitation', label: 'Rehabilitation' },
    { value: 'weight-loss', label: 'Weight Loss' },
    { value: 'bodybuilding', label: 'Bodybuilding' }
  ];

  const priceRangeOptions = [
    { value: 'all', label: 'All Prices' },
    { value: '0-50', label: '$0 - $50/hour' },
    { value: '51-75', label: '$51 - $75/hour' },
    { value: '76-100', label: '$76 - $100/hour' },
    { value: '100+', label: '$100+/hour' }
  ];

  const experienceOptions = [
    { value: 'all', label: 'All Experience Levels' },
    { value: '0-2', label: '0-2 years' },
    { value: '3-5', label: '3-5 years' },
    { value: '6-10', label: '6-10 years' },
    { value: '10+', label: '10+ years' }
  ];

  const sortOptions = [
    { value: 'rating', label: 'Highest Rated' },
    { value: 'experience', label: 'Most Experienced' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'clients', label: 'Most Popular' }
  ];

  return (
    <div className="bg-card border border-border rounded-xl shadow-md p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground flex items-center gap-2">
          <Icon name="Filter" size={20} color="var(--color-primary)" />
          Search & Filter
        </h2>
        <Button
          variant="ghost"
          size="sm"
          iconName="X"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Clear All
        </Button>
      </div>
      <div className="space-y-4">
        <Input
          type="search"
          placeholder="Search trainers by name..."
          value={filters?.searchQuery}
          onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
          className="w-full"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            label="Specialty"
            options={specialtyOptions}
            value={filters?.specialty}
            onChange={(value) => onFilterChange('specialty', value)}
          />

          <Select
            label="Price Range"
            options={priceRangeOptions}
            value={filters?.priceRange}
            onChange={(value) => onFilterChange('priceRange', value)}
          />

          <Select
            label="Experience"
            options={experienceOptions}
            value={filters?.experience}
            onChange={(value) => onFilterChange('experience', value)}
          />

          <Select
            label="Sort By"
            options={sortOptions}
            value={filters?.sortBy}
            onChange={(value) => onFilterChange('sortBy', value)}
          />
        </div>

        <div className="pt-4 border-t border-border">
          <h3 className="text-sm font-semibold text-foreground mb-3 caption">Availability</h3>
          <div className="space-y-2">
            <Checkbox
              label="Available Now"
              checked={filters?.availableNow}
              onChange={(e) => onFilterChange('availableNow', e?.target?.checked)}
            />
            <Checkbox
              label="Featured Trainers Only"
              checked={filters?.featuredOnly}
              onChange={(e) => onFilterChange('featuredOnly', e?.target?.checked)}
            />
            <Checkbox
              label="Accepting New Clients"
              checked={filters?.acceptingClients}
              onChange={(e) => onFilterChange('acceptingClients', e?.target?.checked)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFilters;